// 合约详情页样式（磨砂风格，与抄表页一致）。类名前缀 rcd-
export const HEADER_TOP = 0; // 外层若有固定导航栏，改成它的高度

export const rcdCss = `
.rcd-page{min-height:100vh;background:
  radial-gradient(circle at 12% 6%,rgba(96,165,250,.28),transparent 42%),
  radial-gradient(circle at 92% 32%,rgba(167,139,250,.20),transparent 40%),
  linear-gradient(180deg,#eef3fb,#f4f7fa 45%,#e9f0f8);}
.rcd-main{max-width:760px;margin:0 auto;padding:12px 10px calc(28px + env(safe-area-inset-bottom,0px));}

/* 顶栏：常驻；在顶部时嵌入页面(仅分割线)，滚动后变磨砂+阴影 */
.rcd-bar{position:sticky;z-index:20;padding-top:env(safe-area-inset-top,0px);
  background:rgba(255,255,255,0);border-bottom:1px solid rgba(148,163,184,.3);
  -webkit-backdrop-filter:blur(0) saturate(100%);backdrop-filter:blur(0) saturate(100%);
  transition:background-color .25s,box-shadow .25s,border-color .25s,backdrop-filter .25s,-webkit-backdrop-filter .25s;}
.rcd-bar.scrolled{background:rgba(255,255,255,.72);border-bottom-color:rgba(255,255,255,.6);
  -webkit-backdrop-filter:blur(16px) saturate(180%);backdrop-filter:blur(16px) saturate(180%);
  box-shadow:0 4px 16px rgba(15,23,42,.08);}
.rcd-bar-inner{max-width:760px;margin:0 auto;display:flex;align-items:center;gap:8px;padding:8px 12px;}
.rcd-spacer{flex:1;}

/* 统一的磨砂按钮 */
.rcd-btn{display:inline-flex;align-items:center;justify-content:center;gap:5px;height:36px;padding:0 12px;
  border-radius:10px;border:1px solid rgba(255,255,255,.85);background:rgba(255,255,255,.72);
  box-shadow:0 1px 4px rgba(15,23,42,.08);color:#334155;font:inherit;font-size:13px;font-weight:500;
  white-space:nowrap;cursor:pointer;-webkit-tap-highlight-color:transparent;
  transition:background-color .15s,transform .1s,opacity .15s;}
.rcd-btn:active{background:rgba(219,234,254,.9);transform:scale(.97);}
.rcd-btn.sm{height:32px;padding:0 10px;}
.rcd-btn.icon{width:36px;padding:0;}
.rcd-btn.primary{background:linear-gradient(180deg,#3b82f6,#2563eb);border-color:#2563eb;color:#fff;}
.rcd-btn.primary:active{background:#1d4ed8;}
.rcd-btn.danger{color:#dc2626;border-color:rgba(252,165,165,.9);background:rgba(254,242,242,.8);}
.rcd-btn.danger:active{background:rgba(254,226,226,.95);}
.rcd-btn[disabled]{opacity:.45;cursor:not-allowed;transform:none;}
.rcd-btn.is-hidden{visibility:hidden;pointer-events:none;}
.rcd-counter{min-width:58px;height:36px;padding:0 10px;display:inline-flex;align-items:center;justify-content:center;
  border-radius:10px;border:1px solid rgba(255,255,255,.85);background:rgba(255,255,255,.72);
  box-shadow:0 1px 4px rgba(15,23,42,.08);font-size:13px;font-weight:600;color:#475569;font-variant-numeric:tabular-nums;}

/* 磨砂卡片 */
.rcd-glass{background:rgba(255,255,255,.62);
  -webkit-backdrop-filter:blur(14px) saturate(160%);backdrop-filter:blur(14px) saturate(160%);
  border:1px solid rgba(255,255,255,.75);border-radius:14px;box-shadow:0 2px 12px rgba(15,23,42,.05);overflow:hidden;}

/* 合约信息 */
.rcd-info-head{display:flex;align-items:center;gap:8px;width:100%;padding:12px 14px;border:0;background:transparent;
  font:inherit;text-align:left;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background-color .15s;}
.rcd-info-head:active{background:rgba(59,130,246,.10);}
.rcd-room{font-size:17px;font-weight:600;color:#0f172a;}
.rcd-chev{margin-left:auto;color:#94a3b8;transition:transform .25s;}
.rcd-chev.open{transform:rotate(180deg);}
.rcd-ops{display:flex;flex-wrap:wrap;gap:8px;padding:8px 14px;border-top:1px solid rgba(148,163,184,.22);}
.rcd-collapse{display:grid;grid-template-rows:1fr;transition:grid-template-rows .25s ease;}
.rcd-collapse>div{overflow:hidden;min-height:0;}
.rcd-collapse.closed{grid-template-rows:0fr;}
.rcd-collapse.closed>div{visibility:hidden;transition:visibility 0s .25s;}
.rcd-line{padding:8px 14px;font-size:14px;line-height:1.6;color:#334155;border-top:1px solid rgba(148,163,184,.16);}
.rcd-people{display:flex;flex-wrap:wrap;gap:2px 14px;}
.rcd-mute{color:#94a3b8;font-size:12px;}
.rcd-link{padding:6px 2px;margin:-6px 0;border:0;background:transparent;font:inherit;color:#2563eb;font-weight:500;
  cursor:pointer;-webkit-tap-highlight-color:transparent;}
.rcd-link[disabled]{color:inherit;cursor:default;}
.rcd-chip{display:inline-flex;align-items:center;gap:4px;padding:1px 9px;border-radius:10px;font-size:12px;font-weight:500;}
.rcd-chip.ok{color:#15803d;background:#f0fdf4;border:1px solid #bbf7d0;}
.rcd-chip.no{color:#dc2626;background:#fef2f2;border:1px solid #fecaca;}
.rcd-chips{display:flex;flex-wrap:wrap;gap:8px;}
.rcd-notes{white-space:pre-wrap;word-break:break-word;color:#475569;}

/* Tab（分段） */
.rcd-tabs{display:flex;gap:3px;padding:3px;margin:14px 0 10px;border-radius:12px;background:rgba(148,163,184,.18);}
.rcd-tab{flex:1;height:36px;border:0;border-radius:9px;background:transparent;color:#64748b;font:inherit;font-size:14px;
  font-weight:500;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background-color .2s,color .2s,box-shadow .2s;}
.rcd-tab.on{background:#fff;color:#1d4ed8;box-shadow:0 1px 4px rgba(15,23,42,.12);}

/* 账单列表：工具条 + 分级条 */
.rcd-toolbar{display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin-bottom:12px;}
.rcd-tools{display:flex;gap:6px;margin-left:auto;}
.rcd-lv{display:flex;flex:1 1 200px;min-width:0;overflow:hidden;border-radius:10px;
  border:1px solid rgba(148,163,184,.35);background:rgba(255,255,255,.6);}
.rcd-lv button{flex:1;height:32px;padding:0 8px;border:0;border-right:1px solid rgba(148,163,184,.3);
  background:transparent;color:#64748b;font:inherit;font-size:13px;font-weight:500;white-space:nowrap;cursor:pointer;
  -webkit-tap-highlight-color:transparent;transition:background-color .2s,color .2s;}
.rcd-lv button:last-child{border-right:0;}
.rcd-lv button.in{background:#dbeafe;color:#1d4ed8;}
.rcd-lv button.on{background:#2563eb;color:#fff;}
.rcd-lv .n{margin-left:4px;font-size:11px;opacity:.85;}
.rcd-warn{margin:0 0 10px;padding:8px 12px;border-radius:10px;background:#fffbeb;border:1px solid #fde68a;color:#b45309;font-size:13px;line-height:1.5;}

/* 账单卡片：直接放在页面渐变背景上，用不透明白底+阴影区分层次；不加 blur，避免多层 backdrop-filter 影响滚动性能 */
.rcd-bill{--c:#94a3b8;display:block;margin-bottom:10px;padding:12px 14px 12px 14px;border-radius:12px;
  border:1px solid rgba(255,255,255,.9);border-left:4px solid var(--c);background:rgba(255,255,255,.9);box-shadow:0 1px 6px rgba(15,23,42,.07);
  cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background-color .15s;}
.rcd-bill:last-child{margin-bottom:0;}
.rcd-bill:active{background:rgba(219,234,254,.8);}
.rcd-bill.dim{opacity:.7;}
.rcd-bill-top{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;}
.rcd-bill-l{display:flex;align-items:center;gap:6px;min-width:0;}
.rcd-bill-room{font-size:14px;font-weight:600;color:#0f172a;white-space:nowrap;}
.rcd-bill-type{max-width:110px;padding:0 7px;border-radius:8px;background:#f1f5f9;color:#475569;font-size:12px;
  line-height:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.rcd-bill-r{display:flex;align-items:flex-start;gap:10px;flex-shrink:0;text-align:right;}
.rcd-bill-date{font-size:13px;line-height:20px;font-variant-numeric:tabular-nums;}
.rcd-bill-hint{font-size:11px;line-height:14px;}
.rcd-bill-amt{font-size:13px;line-height:20px;font-weight:600;font-variant-numeric:tabular-nums;}
.rcd-bill-body{margin-top:8px;font-size:12px;line-height:1.7;color:#64748b;word-break:break-word;}
.rcd-empty{padding:24px 0;text-align:center;color:#94a3b8;font-size:13px;}
/* 宽屏（≥1100px）：左右分栏——左侧合约信息吸顶，右侧 tab + 账单/付款记录；账单卡片多列 */
@media (min-width:1100px){
  .rcd-bar-inner,.rcd-main{max-width:1180px;}
  .rcd-main{display:grid;grid-template-columns:380px minmax(0,1fr);gap:16px;align-items:start;}
  .rcd-side{position:sticky;top:68px;max-height:calc(100vh - 84px);overflow:auto;border-radius:14px;}
  .rcd-tabs{margin-top:0;}
  .rcd-bill-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(340px,1fr));gap:10px;}
  .rcd-bill-grid .rcd-bill{margin-bottom:0;}
}
@media (prefers-reduced-motion:reduce){.rcd-collapse,.rcd-chev,.rcd-bar,.rcd-btn{transition:none;}}
`;
